import angular from 'angular';
import _ from 'lodash';
import gridHeight from '../core/shared-service/grid-utils';

class buyersListCtrl {
    /* @ngInject */
    constructor(
        $scope,
        $state,
        $uibModal,
        logger,
        $translate,
        BuyersFilter,
        KissSellerSvc,
        KISS_BUYER,
        PrincipalSvc,
        AuthSvc,
        PrincipalsDA
    ) {
        this.$scope = $scope;
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.logger = logger;
        this.$translate = $translate;
        this.KISS_BUYER = KISS_BUYER;
        this.BuyersFilter = BuyersFilter;
        this.KissSellerSvc = KissSellerSvc;
        this.PrincipalSvc = PrincipalSvc;
        this.AuthSvc = AuthSvc;
        this.PrincipalsDA = PrincipalsDA;
    }

    $onInit() {
        // Mise à jour du status pour menu et boutons
        this.notifNumberUnsent = this.PrincipalSvc.getPrincipBuyersNotifsNumber();
        this.PrincipalSvc.countInvitedBuyersFollowUpNotifiedWithDate(this.PrincipalSvc.getPrincipalId()).then(
            count => (this.shouldDisplayExportFollowupButton = count > 0)
        );

        // Envoi des notifications
        this.displayValidateNotifsProgress = false;

        // Recherche
        this.statusList = this.KISS_BUYER.buyer.status;
        this.langs = this.PrincipalSvc.getLangs();
        this.searchOpen = true;
        this.searchData =
            this.PrincipalSvc.getBuyerListFilter() && this.keepSearchData
                ? this.PrincipalSvc.getBuyerListFilter()
                : new this.BuyersFilter();

        var defaultCellTemplate =
            '<a class="grid-cell-link" ui-sref="app.invitedentity.edit({id: row.entity.id})"><div class="ui-grid-cell-contents ui-grid-cursor-pointer">{{COL_FIELD CUSTOM_FILTERS}}</div></a>';
        var invitationTemplate =
            '<div class="ui-grid-cursor-pointer text-center" ng-click="grid.appScope.$ctrl.viewInvitation(row)"><i class="fa fa-search"></i></div>';
        var relationsTemplate =
            '<div ng-show="row.entity.relations > 0" class="ui-grid-cursor-pointer text-center" ng-click="grid.appScope.$ctrl.viewRelations(row)"><i class="fa fa-search"></i></div>';
        // Liste
        this.gridOptions = {
            columnDefs: [
                {
                    name: 'name',
                    displayName: 'kiss_buyer.list.name',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                },
                {
                    name: 'getLegalId()',
                    displayName: 'kiss_buyer.list.id',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                },
                {
                    name: 'getCountryLabel()',
                    displayName: 'kiss_buyer.list.country',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                },
                {
                    name: 'getLangLabel()',
                    displayName: 'kiss_buyer.list.lang',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                },
                {
                    name: 'getStatusLabel()',
                    displayName: 'kiss_buyer.list.status',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                    width: 80,
                },
                {
                    name: 'invitation',
                    displayName: 'kiss_buyer.list.invitation',
                    headerCellFilter: 'translate',
                    cellTemplate: invitationTemplate,
                    cellClass: 'pointer',
                    width: 80,
                    enableColumnMenu: false,
                    enableSorting: false,
                },
                {
                    name: 'relations',
                    displayName: 'kiss_buyer.list.relations',
                    headerCellFilter: 'translate',
                    cellTemplate: relationsTemplate,
                    cellClass: 'pointer',
                    width: 80,
                    enableColumnMenu: false,
                    enableSorting: false,
                },
            ],
            useExternalPagination: true,
            useExternalSorting: true,
            onRegisterApi: gridApi => {
                this.gridApi = gridApi;
                // Sorting & pagination
                gridApi.core.on.sortChanged(this.$scope, (grid, sortColumns) => {
                    sortColumns = _.map(sortColumns, col => this.convertSort(col));
                    if (sortColumns && sortColumns.length > 0) {
                        this.searchData.setSort(sortColumns);
                    } else {
                        this.searchData.resetSort();
                    }
                    this.search();
                });
                gridApi.pagination.on.paginationChanged(this.$scope, (page, size) => {
                    this.searchData.setPageSize(size);
                    this.searchData.setPage(page - 1);
                    this.search();
                });
            },
            enableSorting: true,
            enableGridMenu: false,
            enableColumnMenus: false,
        };

        this.preparedSearchFilter = {};
        this.headers = [];

        if (!this.searchData.preparBeforeSearch) {
            this.searchData = new this.BuyersFilter();
            this.PrincipalSvc.initBuyerFilterSessionStorage();
        }

        //initialiser le filtre de recherche pour l'export
        this.preparedSearchFilter = this.searchData.preparBeforeSearch();

        //recuperer la liste des headers pour l'export
        this.headers = _.map(this.gridOptions.columnDefs, column => {
            return this.$translate.instant(column.displayName);
        });
        this.search();
    }

    viewInvitation(row) {
        var entity = {
            id: row.entity.id,
            name: row.entity.name,
            status: row.entity.status,
            identifier: row.entity.getLegalId(),
        };
        this.$state.go('app.principal.consult.detailsbuyerinvitation', {
            entity: entity,
            invitationId: row.entity.invitation,
        });
    }

    viewRelations(row) {
        var principalInfo = {
            corporateName: null,
            eid: null,
        };
        if (this.principal && this.principal.detail) {
            principalInfo.corporateName = this.principal.detail.corporateName;
            principalInfo.eid = this.principal.detail.eid;
        }
        this.$state.go('app.principal.invbuyerrelations', { id: row.entity.id, principalInfo: principalInfo });
    }

    convertSort(col) {
        var columnField = _.find(this.KISS_BUYER.buyer.columnFieldMap, { field: col.field });
        if (col && col.sort) {
            return {
                direction: angular.uppercase(col.sort.direction),
                property: columnField ? columnField.property : col.field,
                priority: col.sort.priority,
            };
        }
        return {};
    }

    closeModal(hasUpdate) {
        if (hasUpdate) {
            this.PrincipalSvc.refreshPrincipalBuyersNotifsUnsent(this.PrincipalSvc.getPrincipalId()).then(
                notifNumberUnsent => {
                    this.notifNumberUnsent = notifNumberUnsent;
                }
            );
        }
    }

    searchBuyers(value) {
        if (value && value.length >= 3) {
            return this.PrincipalSvc.searchBuyersByNameOrId(this.principal.detail.id, value).then(buyers => {
                return buyers;
            });
        }
    }

    search() {
        // Dans le cas où l'on recharge une page de données différente de la 1ere sans passer par l'IHM
        // de pagination de la grille alors la grille se recharge en indiquant que l'on affiche la page 1
        // alors qu'il s'agit en fait de la page n.
        // La solution pérenne est plutôt de passer par un save/restoreState afin de récupérer la pagination
        // ainsi que les indicateurs de tri sur les colonnes
        if (this.gridOptions.paginationCurrentPage === undefined && this.searchData.pageCriteria.page > 0) {
            this.gridOptions.totalItems = 99999;
            this.gridOptions.paginationCurrentPage = this.searchData.pageCriteria.page + 1;
            this.search();
        } else {
            this.kissBuyerPromise = this.PrincipalSvc.searchBuyers(this.principal.detail.id, this.searchData);
            this.kissBuyerPromise.then(
                pageBuyers => {
                    this.gridOptions.data = pageBuyers.buyers;
                    this.gridOptions.totalItems = pageBuyers.totalItems;
                    //enregistrer le filtre de recherche formaté pour l'export
                    this.preparedSearchFilter = this.searchData.preparBeforeSearch();
                },
                (/*error*/) => {
                    this.logger.error('error.search');
                }
            );
        }
    }

    clearForm() {
        // Reset data
        this.searchData = new this.BuyersFilter();
        // Reset form
        this.form.$setPristine();
        // Recherche
        this.search();
    }

    /**
     * Fournit la hauteur optimale de la grid en fonction du nombre d'element par page.
     */
    getGridHeight(gridApi) {
        return gridHeight(gridApi);
    }

    backList() {
        this.$state.go('do', { tabName: 'principal' });
    }

    isEditAuthorized() {
        return this.AuthSvc.isEditAuthorized();
    }
    execValidateBuyerNotifs() {
        this.PrincipalSvc.sendBuyersNotifications(this.principal.detail.id).then(
            taskId => {
                this.csvValidateNotifsTaskId = taskId;
                this.displayValidateNotifsProgress = true;
            },
            error => {
                if (error.status === 400 && error.data && error.data.code === 'OPERATION_ALREADY_IN_EXECUTION') {
                    this.logger.error('error.operation_already_inprogress');
                } else {
                    // TODO voir ce qu'on fait ici
                    this.logger.error('error.notifications');
                }
            }
        );
    }

    onValidateNotifsBuyersTaskEnd(result) {
        let res = result;
        if (result.result) {
            res = result.result;
        }

        this.displayValidateNotifsProgress = false;
        if (result) {
            this.$uibModal
                .open({
                    component: 'modalNotification',
                    resolve: {
                        principal: () => {
                            return this.principal;
                        },
                        reportData: () => {
                            return this.PrincipalSvc.getReportWithLink(res);
                        },
                        type: () => {
                            return 'buyers';
                        },
                    },
                    backdrop: 'static',
                    keyboard: false,
                })
                .result.then(
                    this.PrincipalSvc.refreshPrincipalBuyersNotifsUnsent(this.PrincipalSvc.getPrincipalId()).then(
                        notifNumberUnsent => {
                            this.notifNumberUnsent = notifNumberUnsent;
                        }
                    ),
                    hasUpdate => this.closeModal(hasUpdate),
                    () => {}
                );
        } else {
            this.logger.error('error.generic');
        }
    }

    openImportBuyers() {
        this.$uibModal
            .open({
                component: 'modalImport',
                resolve: {
                    principal: () => {
                        return this.principal;
                    },
                    type: () => {
                        return 'buyers';
                    },
                },
                backdrop: 'static',
                keyboard: false,
            })
            .result.then(
                hasUpdate => this.closeModal(hasUpdate),
                () => {}
            );
    }

    openImportRelations() {
        this.$uibModal
            .open({
                component: 'buyerModelImport',
                resolve: {
                    principal: () => {
                        return this.principal;
                    },
                    type: () => {
                        return 'buyersrelations';
                    },
                },
                backdrop: 'static',
                keyboard: false,
            })
            .result.then(hasUpdate => this.closeModal(hasUpdate));
    }

    exportFollowUpAllClients() {
        this.$uibModal.open({
            component: 'confirmationExportFollowupModal',
            resolve: {
                principal: () => this.principal,
                type: () => 'buyer',
            },
            backdrop: 'static',
            keyboard: false,
        }).result;
    }
}

angular.module('app.principal').component('buyersList', {
    templateUrl: require('./buyers-list.html'),
    controller: buyersListCtrl,
    bindings: {
        principal: '<',
        keepSearchData: '<',
    },
});


